import React from 'react'
import { FollowButton } from './follow'
 
export const Onlines = ({data}) => {
    
    return (
        <div>
            onlines: {data?.length>0&&data.map((user)=>{ 
                return <div key={'online-'+user}>
                   <OnlineUser id={user} data={data} />
                </div>
            })}
        </div>
    )
}


export const OnlineUser = ({id}) => {
    const [user]  = React.useState({});
    const getUser = async () => {}
    React.useEffect(()=>{
        getUser();
    },[])
  
   return (
       <div>
           <b>#{id} - {user?.name}</b>
           <br />
       </div>
   )
}

export const OnlineItem = ({id, user}) =>{
    const [active] = React.useState(true)

   return (
       <li>
           <a href={`/users/${user.id}`}>
            {user.avatar ? <img alt="avatar" src={`/assets/images/faces/${user.avatar}.png`} style={{border:`5px solid ${active && 'lightgreen'}`, borderRadius:'50%', }} className={`${active && 'online'}`} /> : <img alt="avatar" src="/faces/default.svg" /> }
            <div>
                <div className="flex-start">
                    <h3 className="title">{user.name}</h3> 
                    {active && (
                        <React.Fragment> 
                        <small style={{color:'green', padding:'3px 5px', background:'lightgreen',borderRadius:'10px', marginLeft:'7px'}}> {active && 'online'} </small> 
                        </React.Fragment>)
                    } 
                </div>
               <b  className="position">{user.position}</b>
               <p  className="description">{user.description}</p> 
            </div>
        </a>
        <div>
        {false && <FollowButton  id={user._id} />}
        </div>
    </li>
   )
}
